import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSelectModeIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 176,
	height: 168,
	viewBox: "0 0 176 168",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 91.1953,
			cy: 84,
			r: 84,
			fill: "#F0EEFF"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_6477_110417",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 7,
			y: 0,
			width: 169,
			height: 168,
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 91.1953,
				cy: 84,
				r: 84,
				fill: "#D9D9D9"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask0_6477_110417)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M95.1826 91.4727L43.8672 144.948",
					stroke: "#0DC277",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M43.8555 161.144C39.83 161.144 35.8014 159.626 32.6826 156.576C26.3182 150.35 26.1611 140.097 32.3323 133.675L83.6477 80.1989C89.8195 73.7773 99.9812 73.6194 106.347 79.8454C112.711 86.0714 112.868 96.3248 106.697 102.746L55.3818 156.223C52.2338 159.498 48.0462 161.144 43.8555 161.144Z",
					fill: "#0DC277",
					stroke: "#3C3C3C",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M80.3219 58.5051C78.0159 59.0119 72.2749 61.458 66.551 67.6309C63.4341 70.9929 52.8783 89.586 50.7034 93.4414L50.1016 94.1617L72.6594 94.2045C72.6594 94.2045 77.8163 77.3883 79.0124 75.0381C81.1151 70.9073 83.0683 67.3325 81.3476 66.9739C79.6276 66.6153 78.6488 67.9531 76.8255 70.5461C70.2876 79.8433 69.7472 73.3047 69.7231 73.0989C69.6832 72.757 72.2958 68.2234 73.0446 67.4628C75.7187 64.7471 77.8322 62.9453 81.1474 60.4487C81.914 59.8716 81.4052 58.266 80.3225 58.5044L80.3219 58.5051Z",
					fill: "#FFF5E2",
					stroke: "#3C3C3C",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M51.2266 94.4027L72.6897 90.0027L75.8795 76.1062L68.0263 68.2656L55.0252 87.5317L51.2266 94.4027Z",
					fill: "#FFF5E2"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M72.2378 65.7344C72.2378 65.7344 75.064 66.3122 77.0431 66.9679C78.0821 67.3118 80.1106 69.9605 80.5807 70.7147C82.1936 73.3039 80.9792 74.0613 79.2395 73.1358C77.6044 72.2659 76.9544 71.0119 75.3288 70.4015C73.8115 69.832 70.0312 70.0902 70.0312 70.0902",
					fill: "#FFF5E2"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M72.2378 65.7344C72.2378 65.7344 75.064 66.3122 77.0431 66.9679C78.0821 67.3118 80.1106 69.9605 80.5807 70.7147C82.1936 73.3039 80.9792 74.0613 79.2395 73.1358C77.6044 72.2659 76.9544 71.0119 75.3288 70.4015C73.8115 69.832 70.0312 70.0902 70.0312 70.0902",
					stroke: "#3C3C3C",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M69.7799 68.3477C69.7799 68.3477 73.0057 69.2738 74.926 70.1603C75.92 70.6192 77.6033 73.1631 77.8909 74.0061C78.3324 75.2991 78.2691 76.0156 77.3061 76.1786C75.932 76.4113 74.7011 73.7121 73.0755 73.1017C71.5582 72.5322 67.3047 71.399 67.3047 71.399",
					fill: "#FFF5E2"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M69.7799 68.3477C69.7799 68.3477 73.0057 69.2738 74.926 70.1603C75.92 70.6192 77.6033 73.1631 77.8909 74.0061C78.3324 75.2991 78.2691 76.0156 77.3061 76.1786C75.932 76.4113 74.7011 73.7121 73.0755 73.1017C71.5582 72.5322 67.3047 71.399 67.3047 71.399",
					stroke: "#3C3C3C",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M70.8749 72.4609C73.3874 74.0889 73.5002 75.4905 73.6282 76.2173C73.8461 77.454 73.0656 77.9225 72.2319 77.463C71.1232 76.8526 69.5502 75.387 68.8704 75.1908C67.4602 74.7824 65.0781 74.6405 65.0781 74.6405",
					fill: "#FFF5E2"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M70.8749 72.4609C73.3874 74.0889 73.5002 75.4905 73.6282 76.2173C73.8461 77.454 73.0656 77.9225 72.2319 77.463C71.1232 76.8526 69.5502 75.387 68.8704 75.1908C67.4602 74.7824 65.0781 74.6405 65.0781 74.6405",
					stroke: "#3C3C3C",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.7398 160.17L48.8795 160.55C40.9503 164.055 31.706 160.412 28.2317 152.412C26.3882 148.167 26.5643 143.493 28.2982 139.568L51.579 85.2578L76.7229 94.9263L55 148.577",
					fill: "#0DC277"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.7398 160.17L48.8795 160.55C40.9503 164.055 31.706 160.412 28.2317 152.412C26.3882 148.167 26.5643 143.493 28.2982 139.568L51.579 85.2578L76.7229 94.9263L55 148.577",
					stroke: "#3C3C3C",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M77.5084 107.748C78.9047 96.8959 81.8506 89.83 83.0398 84.7347C84.5057 78.4511 90.4203 74.2883 96.7739 75.0508L127.327 79.8266C143.188 82.2107 147.501 88.4603 148.188 96.0529C148.701 101.726 143.574 126.379 141.029 137.603C137.065 155.083 133.236 176.001 133.236 176.001L63.7344 166.455L77.5091 107.748H77.5084Z",
					fill: "#0DC277",
					stroke: "#3C3C3C",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M113.26 54.4323C124.147 54.4323 132.972 45.5281 132.972 34.5443C132.972 23.5604 124.147 14.6562 113.26 14.6562C102.373 14.6562 93.5469 23.5604 93.5469 34.5443C93.5469 45.5281 102.373 54.4323 113.26 54.4323Z",
					fill: "#3C3C3C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M127.245 42.2017C127.245 42.2017 117.566 24.5693 107.122 24.6408C99.2695 24.6952 96.4332 28.9705 92.6555 35.3748C90.6561 38.7643 89.7331 56.196 93.6147 63.0529C95.2732 65.9828 98.5042 67.8849 103.603 68.7727L103.728 80.4105C103.728 80.4105 102.931 91.2314 115.106 91.1541C128.846 91.0665 127.44 79.7822 127.44 79.7822L127.245 42.2017Z",
					fill: "#FFF5E2",
					stroke: "#3C3C3C",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M121.289 39.8816L121.468 40.515L123.535 47.8199L126.875 48.3791L128.979 43.5337L128.46 34.9153L121.772 33.4766",
					fill: "#3C3C3C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M123.702 55.5955C126.716 55.2989 128.919 52.5595 128.621 49.4775C128.336 46.5278 125.862 44.3393 123.008 44.416",
					fill: "#FFF5E2"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M123.702 55.5955C126.716 55.2989 128.919 52.5595 128.621 49.4775C128.336 46.5278 125.862 44.3393 123.008 44.416",
					stroke: "#3C3C3C",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M83.6412 33.6453L114.373 34.0186C114.373 34.0186 112.685 41.6348 119.666 45.0965L120.671 50.4941L122.965 50.4782L124.28 41.5549L122.41 22.2645L105.557 16.5312L88.2039 22.5003L83.6406 33.646L83.6412 33.6453Z",
					fill: "#3C3C3C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M89.4116 38.8196C96.4562 38.8196 102.167 33.0581 102.167 25.9508C102.167 18.8436 96.4562 13.082 89.4116 13.082C82.367 13.082 76.6562 18.8436 76.6562 25.9508C76.6562 33.0581 82.367 38.8196 89.4116 38.8196Z",
					fill: "#3C3C3C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M103.859 30.5242C109.943 30.5242 114.875 25.5484 114.875 19.4105C114.875 13.2726 109.943 8.29688 103.859 8.29688C97.7757 8.29688 92.8438 13.2726 92.8438 19.4105C92.8438 25.5484 97.7757 30.5242 103.859 30.5242Z",
					fill: "#3C3C3C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M103.734 68.7774C103.734 68.7774 108.931 69.8614 113.992 66.75L103.734 68.7774Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M103.734 68.7774C103.734 68.7774 108.931 69.8614 113.992 66.75",
					stroke: "#3C3C3C",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M104.66 44.5161L104.651 44.4203C104.656 44.288 104.629 44.1652 104.569 44.0508C104.531 43.932 104.466 43.8291 104.373 43.7421C104.287 43.6488 104.185 43.5823 104.067 43.544C103.954 43.4839 103.832 43.4564 103.701 43.4615L103.448 43.4961C103.287 43.5414 103.147 43.6239 103.029 43.7428L102.88 43.9371C102.794 44.0866 102.751 44.2477 102.75 44.4209L102.759 44.5168C102.754 44.6491 102.781 44.7718 102.841 44.8862C102.879 45.0051 102.944 45.108 103.037 45.1949C103.123 45.2882 103.225 45.3547 103.343 45.3931C103.456 45.4532 103.578 45.4806 103.709 45.4755L103.962 45.441C104.123 45.3956 104.263 45.3132 104.381 45.1943L104.53 45C104.616 44.8504 104.659 44.6894 104.66 44.5161Z",
					fill: "#3C3C3C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M93.7929 45.1724C93.7897 45.1404 93.7872 45.1085 93.784 45.0765C93.7891 44.9442 93.7618 44.8215 93.7023 44.7071C93.6642 44.5882 93.5984 44.4853 93.5059 44.3984C93.4197 44.3051 93.3177 44.2386 93.1999 44.2002C93.0865 44.1402 92.9649 44.1127 92.8337 44.1178L92.5809 44.1523C92.42 44.1977 92.28 44.2801 92.1615 44.399L92.0127 44.5933C91.9265 44.7429 91.8834 44.904 91.8828 45.0772C91.886 45.1091 91.8885 45.1411 91.8917 45.173C91.8866 45.3053 91.9138 45.4281 91.9734 45.5425C92.0114 45.6614 92.0773 45.7643 92.1698 45.8512C92.2559 45.9445 92.3579 46.011 92.4758 46.0493C92.5892 46.1094 92.7108 46.1369 92.842 46.1318L93.0947 46.0973C93.2556 46.0519 93.3956 45.9694 93.5141 45.8505L93.663 45.6562C93.7492 45.5067 93.7922 45.3456 93.7929 45.1724Z",
					fill: "#3C3C3C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M95.5648 49.5352L94.9629 52.2503C94.8521 52.7514 95.281 53.2058 95.7827 53.1183L98.1673 52.7003",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M95.5648 49.5352L94.9629 52.2503C94.8521 52.7514 95.281 53.2058 95.7827 53.1183L98.1673 52.7003",
					stroke: "#3C3C3C",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M101.523 39.9474C101.523 39.9474 104.957 38.7662 106.693 41.0691L101.523 39.9474Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M101.523 39.9474C101.523 39.9474 104.957 38.7662 106.693 41.0691",
					stroke: "#3C3C3C",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M88.4922 42.5776C88.4922 42.5776 90.8533 39.7992 93.5091 40.8909",
					stroke: "#3C3C3C",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M113.981 66.75L103.72 78.2261L103.633 69.1417C103.633 69.1417 106.385 69.4728 109.446 68.617C112.507 67.7618 113.981 66.75 113.981 66.75Z",
					fill: "#3C3C3C",
					stroke: "#3C3C3C",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M104.006 56.6602C104.006 56.6602 102.56 59.2417 99.2031 57.9097L104.006 56.6602Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M104.006 56.6602C104.006 56.6602 102.56 59.2417 99.2031 57.9097",
					stroke: "#3C3C3C",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M38.9474 104.091C36.5235 98.6707 38.7928 94.6657 39.375 93.2046C40.4868 90.4153 39.8837 86.9945 39.7209 84.2021C39.5562 81.3738 39.8305 79.1898 40.8486 79.0255C44.1106 78.4989 47.7679 89.8132 51.5691 100.04C55.0167 109.316 58.7488 111.545 58.7488 111.545L48.6124 114.953",
					fill: "#FFF5E2"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M38.9474 104.091C36.5235 98.6707 38.7928 94.6657 39.375 93.2046C40.4868 90.4153 39.8837 86.9945 39.7209 84.2021C39.5562 81.3738 39.8305 79.1898 40.8486 79.0255C44.1106 78.4989 47.7679 89.8132 51.5691 100.04C55.0167 109.316 58.7488 111.545 58.7488 111.545L48.6124 114.953",
					stroke: "#3C3C3C",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M43.5729 100.914L37.4886 62.3398L20.2656 64.9687L25.0278 102.457L43.5729 100.914Z",
					fill: "#646464",
					stroke: "#3C3C3C",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M24.5781 79.918L35.1896 83.5931L43.7422 86.7889L47.2266 103.886L39.7827 107.562L32.9818 102.597L27.429 96.8556L24.5781 79.918Z",
					fill: "#FFF5E2"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.0509 84.1543C21.4082 81.0384 16.1816 79.6003 17.9238 76.7241C19.1636 74.6776 41.8393 85.9919 41.8393 85.9919",
					fill: "#FFF5E2"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.0509 84.1543C21.4082 81.0384 16.1816 79.6003 17.9238 76.7241C19.1636 74.6776 41.8393 85.9919 41.8393 85.9919",
					stroke: "#3C3C3C",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M31.2271 86.7885L24.0448 83.569C23.5551 83.2616 22.9703 83.2117 22.4382 83.4342C21.9098 83.656 21.5323 84.1066 21.4043 84.6703L21.3333 84.9816C21.1572 85.755 21.4264 87.2276 22.1594 87.6769C22.4027 87.8258 22.665 87.9709 22.9355 88.1122C22.4167 88.4324 21.9859 89.023 21.8458 89.6378L21.7755 89.9485C21.6197 90.6324 21.7736 92.1178 22.6219 92.5172L22.7771 92.5907C22.9279 92.6623 23.0863 92.7365 23.2478 92.8112C23.0464 93.0433 22.2893 93.9943 22.4281 95.0598C22.5142 95.7213 23.0027 96.1617 23.6248 96.7152C24.6473 97.6247 48.6053 115.807 48.6053 115.807",
					fill: "#FFF5E2"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M31.2271 86.7885L24.0448 83.569C23.5551 83.2616 22.9703 83.2117 22.4382 83.4342C21.9098 83.656 21.5323 84.1066 21.4043 84.6703L21.3333 84.9816C21.1572 85.755 21.4264 87.2276 22.1594 87.6769C22.4027 87.8258 22.665 87.9709 22.9355 88.1122C22.4167 88.4324 21.9859 89.023 21.8458 89.6378L21.7755 89.9485C21.6197 90.6324 21.7736 92.1178 22.6219 92.5172L22.7771 92.5907C22.9279 92.6623 23.0863 92.7365 23.2478 92.8112C23.0464 93.0433 22.2893 93.9943 22.4281 95.0598C22.5142 95.7213 23.0027 96.1617 23.6248 96.7152C24.6473 97.6247 48.6053 115.807 48.6053 115.807",
					stroke: "#3C3C3C",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M22.6719 87.9883L30.5117 91.1042",
					stroke: "#3C3C3C",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M23.25 92.8086L29.883 95.8152",
					stroke: "#3C3C3C",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M132.365 124.489L102.95 150.326L102.639 150.599C96.8864 155.652 88.4935 155.671 82.7373 151.037L34.8594 112.553L52.2788 89.2732L91.4255 117.502L119.385 89.1038C119.385 89.1038 127.873 80.0086 134.004 81.2301",
					fill: "#0DC277"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M132.365 124.489L102.95 150.326L102.639 150.599C96.8864 155.652 88.4935 155.671 82.7373 151.037L34.8594 112.553L52.2788 89.2732L91.4255 117.502L119.385 89.1038C119.385 89.1038 127.873 80.0086 134.004 81.2301",
					stroke: "#3C3C3C",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter0_d_6477_110417)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M22.3114 36.887L17.5506 38.342C17.4021 37.876 17.1458 37.4476 16.797 37.0821C16.4483 36.7167 16.0142 36.4218 15.5206 36.215C15.0271 36.0083 14.4842 35.8938 13.9244 35.8786C13.3646 35.8633 12.7993 35.9476 12.2622 36.1263C11.4538 36.3431 10.726 36.7724 10.181 37.3539C9.63605 37.9354 9.30123 38.6399 9.2236 39.3685C9.14825 39.9763 9.23641 40.5814 9.48095 41.1348C9.72549 41.6881 10.1195 42.1741 10.6311 42.5533C11.8065 43.3991 13.9009 43.964 16.9816 42.4803L19.9969 51.6927L15.2871 53.132L13.5195 47.7317C11.436 47.8365 9.4173 47.3407 7.77228 46.3201C6.12727 45.2995 4.94657 43.8104 4.41086 42.0805C2.45319 36.0996 8.24286 32.8119 10.936 31.9888C12.9491 31.3615 20.0523 29.6847 22.3114 36.887Z",
				fill: "#FC8210"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M15.8592 55.0644L20.6328 53.6055L21.8841 57.4285L17.1105 58.8873L15.8592 55.0644Z",
				fill: "#FC8210"
			})]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
			id: "filter0_d_6477_110417",
			x: .015625,
			y: 31.3633,
			width: 26.2969,
			height: 35.5234,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 4 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.778971 0 0 0 0 0.778971 0 0 0 0 0.778971 0 0 0 0.2 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_6477_110417"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_6477_110417",
					result: "shape"
				})
			]
		}) })
	]
});
export default SvgSelectModeIcon;
